import api from "./client";

// System-level read-only endpoints.
export const systemAPI = {
  // Returns { openai: bool, anthropic: bool, gemini: bool, elevenlabs: bool,
  // cartesia: bool, deepgram: bool, assemblyai: bool } — true means the
  // provider's API key is actually set in the backend ENV. Used by the
  // Model Settings UI to show the "missing key" warning only when warranted.
  getProviderApiKeyStatus: async () => {
    const response = await api.get("/api/v1/system/provider_api_key_status");
    return response.data;
  },
};
